import { render } from "./TemplateDatatableFormFullTreatmentTemplateForm.vue?vue&type=template&id=34374784&scoped=true"
import script from "./TemplateDatatableFormFullTreatmentTemplateForm.vue?vue&type=script&lang=js"
export * from "./TemplateDatatableFormFullTreatmentTemplateForm.vue?vue&type=script&lang=js"

import "./TemplateDatatableFormFullTreatmentTemplateForm.vue?vue&type=style&index=0&id=34374784&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34374784"]])

export default __exports__